import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SocialWallDetailDialogComponent } from './social-wall-detail-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class SocialWallDialogService {

  private readonly dialog = inject(MatDialog);

  public openDetail(config: { items: any[], index?: number }): MatDialogRef<SocialWallDetailDialogComponent> {
    return this.dialog.open(SocialWallDetailDialogComponent, {
      data: { items: config.items ?? [], activeIndex: config.index ?? 0 },
      backdropClass: ['custom-overlay-backdrop'],
      panelClass: 'social-wall-detail-panel',
      maxWidth: '100vw',
      maxHeight: '100vh',
      autoFocus: false
    });
  }

}
